import { appraisalUserAction } from "../config/action-config";

const initialUser = { isLoggedIn: false, err: false };

const appraisalUser = (user = initialUser, action) => {
  const { payload, type } = action;
  switch (type) {
    case appraisalUserAction.SET_USER_DATA:
      return { ...payload };

    default:
      return user;
  }
};

export default appraisalUser;
